function closeAllCards() {
  
  document.querySelectorAll('.product-card.active').forEach(card => {
    card.classList.remove('active');
  });
  document.body.classList.remove('size-active');
}

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

function initializeProductCard(cardContainer) {
  if (cardContainer.dataset.jsInitialized === 'true') return;

  const card = cardContainer.querySelector('.product-card');
  if (!card) return;

  const addButton = card.querySelector('.add-button');
  if (!addButton) return;

  const productData = JSON.parse(cardContainer.querySelector('.product-json').textContent);
  const sizeOptions = card.querySelector('.extra-options');
  const customAddButton = card.querySelector('.custom-add-button');

  let selectedColor = null;
  let selectedSize = null;

  // --- Swatches ---
  const swatches = card.querySelectorAll('.swatchpdp');
  swatches.forEach(swatch => {
    swatch.addEventListener('click', function () {
      swatches.forEach(s => s.classList.remove('selected'));
      this.classList.add('selected');

      selectedColor = this.dataset.colorName?.trim();

      // Update product image on color change
      const imageUrl = this.dataset.image;
      if (imageUrl) {
        const imageElement = card.querySelector('.product-image-wrapper img');
        if (imageElement) {
          imageElement.src = imageUrl;
        }
      }

      if (sizeOptions) sizeOptions.style.display = 'block';
      if (customAddButton) customAddButton.classList.add('show-sizes');

      selectedSize = null;
      card.querySelectorAll('.sizes .size').forEach(btn => btn.classList.remove('selected'));
      updateVariant();
    });
  });

// Size selection logic
const sizeButtons = card.querySelectorAll('.sizes .size');
sizeButtons.forEach(button => {
  button.addEventListener('click', function(e) {
    const selectedSwatch = card.querySelector('.swatchpdp.selected');
    if (!selectedSwatch) {
      //alert('Please select a color.');
      return;
    }

    // Remove previous selection + loader from all
    sizeButtons.forEach(btn => {
      btn.classList.remove('selected');
      btn.classList.remove('loading');
    });

    const selectedColor = selectedSwatch.dataset.colorName;
    const selectedSize = this.querySelector('span').textContent.trim();
    const selectedVariant = productData.variants.find(v => {
      return v.options.includes(selectedColor) && v.options.includes(selectedSize);
    });

    const clickedButton = this;
    clickedButton.classList.add('selected');
    clickedButton.classList.add('loading');

    if (selectedVariant) {
      const form = clickedButton.closest('form');
      form.querySelector('.product-variant-id').value = selectedVariant.id;

      // Simulate async loader removal after small delay
      setTimeout(() => {
        clickedButton.classList.remove('loading');

        // ONLY submit if NOT in bundle mode
        if (!cardContainer.dataset.bundleMode) {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        } else {
          e.preventDefault();
        }
      }, 100); // You can tweak this duration if needed
    } else {
      alert('This combination is not available.');
      clickedButton.classList.remove('loading');
      e.preventDefault();
    }
  });
});


  // --- Auto-select color only (no size auto-select) ---
  const firstSwatch = card.querySelector('.swatchpdp');
  if (firstSwatch) {
    firstSwatch.classList.add('selected');
    selectedColor = firstSwatch.dataset.colorName?.trim();

    if (sizeOptions) sizeOptions.style.display = 'block';
    if (customAddButton) customAddButton.classList.add('show-sizes');
  }

  function updateVariant() {
    if (selectedColor && selectedSize) {
      const variant = productData.variants.find(v =>
        v.options.includes(selectedColor) && v.options.includes(selectedSize)
      );
      if (variant) {
        const form = card.querySelector('form');
        if (form) {
          form.querySelector('.product-variant-id').value = variant.id;
        }
      }
    }
  }

  // --- Add Button Behavior ---
  if (isTouchDevice()) {
    addButton.addEventListener('click', (e) => {
      e.stopPropagation();
      const isActive = card.classList.contains('active');
      closeAllCards();
      const isInBundle = card.closest('.bundle-builder-container');
      if (!isActive) {
        card.classList.add('active');
        if (!isInBundle) {
          document.body.classList.add('size-active');
        }
      }
    });
    // Add close button handler for mobile
    const closeBtn = card.querySelector('.extra-options-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        closeAllCards();
      });
    }
  } else {
    addButton.addEventListener('mouseenter', () => {
      card.classList.add('active');
    });

    card.addEventListener('mouseleave', () => {
      if (!addButton.matches(':focus')) {
        card.classList.remove('active');
      }
    });

    addButton.addEventListener('click', (e) => {
      e.stopPropagation();
      const isActive = card.classList.contains('active');
      closeAllCards();
      const isInBundle = card.closest('.bundle-builder-container');
      if (!isActive) {
        card.classList.add('active');
        if (!isInBundle) {
          document.body.classList.add('size-active');
        }
      }
    });
  }

  cardContainer.dataset.jsInitialized = 'true';
}

function initializeAllProductCards() {
  document.querySelectorAll('.product-card-container').forEach(initializeProductCard);
}

function watchForRecommendationsLoad() {
  const observer = new MutationObserver(() => {
    initializeAllProductCards();
  });

  document.querySelectorAll('product-recommendations').forEach((el) => {
    observer.observe(el, {
      childList: true,
      subtree: true
    });
  });
}

// --- Cross-sell slider observer ---
(function observeCrossSellSlider() {
  const crossSellSlider = document.querySelector('.cross-sell-slider');
  if (!crossSellSlider) return;
  const observer = new MutationObserver(() => {
    initializeAllProductCards();
  });
  observer.observe(crossSellSlider, { childList: true, subtree: true });
})();

document.addEventListener('DOMContentLoaded', () => {
  initializeAllProductCards();
  watchForRecommendationsLoad();

  document.addEventListener('shopify:section:load', () => {
    initializeAllProductCards();
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.product-card-container')) {
      closeAllCards();
    }
  });
});

window.initializeAllProductCards = initializeAllProductCards;



 document.querySelectorAll(".product-card").forEach(function (card, index) {
  // Ignorar tarjetas dentro del bundle
  if (card.closest(".bundle-product")) return;

  const imageEl = card.querySelector(".product-card-image");
  const swatches = card.querySelectorAll(".swatchpdp");

  if (!imageEl || swatches.length === 0) return;

  let originalSrc = imageEl.getAttribute("src");
  let lockedSrc = null;

  swatches.forEach(function (swatch, i) {
    const newImage = swatch.dataset.image;
    if (!newImage) return;

    // Hover → cambia si no hay imagen fijada
    swatch.addEventListener("mouseenter", function () {
      if (!lockedSrc) {
        imageEl.setAttribute("src", newImage);
      }
    });

    // Mouseleave → solo restaura si no hay imagen fijada
    swatch.addEventListener("mouseleave", function () {
      if (!lockedSrc) {
        imageEl.setAttribute("src", originalSrc);
      }
    });

    // Click → bloquea la imagen seleccionada
    swatch.addEventListener("click", function () {
      imageEl.setAttribute("src", newImage);
      lockedSrc = newImage;
      originalSrc = newImage; // por si vuelves a interactuar, esto se convierte en la nueva base

      // Visual: marcar swatch activo
      swatches.forEach(s => s.classList.remove("selected"));
      swatch.classList.add("selected");
    });
  });
});